import { render, staticRenderFns } from "./UserSettingList.vue?vue&type=template&id=2dcd689d&"
import script from "./UserSettingList.vue?vue&type=script&lang=js&"
export * from "./UserSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports